import { createSlice } from '@reduxjs/toolkit';

const queryString = window.location.search;
const params = new URLSearchParams(queryString);

const handleCriteria = () => {
  if (params.get('more_criteria')) return params.get('more_criteria').split(',') || [];
  return ['display_for_sale', 'with_renovation', 'without_renovation']
}

const handleBudget = () => {
  if (document.referrer.includes('premium')) return { min_budget: '1 000 000', max_budget: '' }

  return { min_budget: params.get('min_budget') || '', max_budget: params.get('max_budget') || ''}
}

const handleZones = () => {
  const zonesParam = params.get('zones');
  if (!zonesParam) return [];
  
  // Try to parse as JSON (new format)
  try {
    const parsed = JSON.parse(zonesParam);
    if (Array.isArray(parsed)) return parsed;
  } catch (e) {
    // Not JSON, fallback to old comma-separated format
  }
  
  // Old format: comma-separated strings
  return zonesParam.split(',').filter(zone => zone !== '');
}

const initialFilters = {
  zones: handleZones(),
  type: { apartment: checkBoolean(params.get('apartment')), house: checkBoolean(params.get('house')) },
  budget: handleBudget(),
  surface: { min_area: params.get('min_area') || '', max_area: params.get('max_area') || '' },
  room: { min_room_number: params.get('min_room_number') || '', min_bedroom_number: params.get('min_bedroom_number') || '' },
  more_criteria: [...new Set([...handleCriteria()])],
  dpe: params.get('dpe')?.split(',') || ['A','B','C','D','E','F','G']
}

const initialState = {
  freezeCollection: initialFilters,
  collection: initialFilters,
  baseCollection: initialFilters,
  selectedTab: null,
  sortFilter: '',
  filtersChanged: false,
  sharedByUser: params.get('shared_by_user') || null,
  hasUnsavedFilters: false
};

export const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setSelectedTab: (state, { payload }) => {
      state.selectedTab = payload;
    },
    updateFilters: (state, { payload }) => {
      state.collection = payload;
      state.collection = { ...state.collection, ...payload };
      state.hasUnsavedFilters = true;
    },
    updateBaseFilters: (state) => {
      state.baseCollection = state.collection;
      state.sharedByUser = null
      state.hasUnsavedFilters = false;
      state.filtersChanged = true;
    },
    sortFilter: (state, { payload }) => {
      state.sortFilter = payload;
    }
  },
})

export const { setSelectedTab, updateFilters, updateBaseFilters, sortFilter } = filtersSlice.actions;

export default filtersSlice.reducer;

function checkBoolean(val) {
  // We want true by default
  if (!val) return true;

  return val === 'true';
}
